import { httpRequest } from "../../http";
import { ScheduleEntry } from "@models/ScheduleEntry.model";
import { ScheduleEntrySerializer } from "@models/serializers/scheduleEntrySerializer";

export class CommandUpdateScheduleEntry {
    async run(entryId: number, entry: Partial<ScheduleEntry>) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/schedules/entries/${entryId}`
       
        try {
            const response = await httpRequest<any>(url, { method: "PATCH", body: new ScheduleEntrySerializer().serialize(entry) });
            return this.deserialize(response);
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) {
        return new ScheduleEntrySerializer().deserialize(data)
    }

  
}



